export function showModalToOrder() {
	app.modal.open('#modal-to-order');
}
